import React from 'react';

const Notifications = () => {
  // TODO: Integrate with push/email notification backend
  return (
    <div>
      <h2>Bildirimler / Anlık Uyarılar</h2>
      <p>Burada geç kalma, çıkış yapmama, fazla mesai vb. bildirimler gösterilecek.</p>
    </div>
  );
};

export default Notifications;
